// extracted by mini-css-extract-plugin
module.exports = {"OrgEmbeddedLoadingBase":"OrgEmbeddedLoading_OrgEmbeddedLoadingBase__2J_F7","OrgEmbeddedLoadingIcon":"OrgEmbeddedLoading_OrgEmbeddedLoadingIcon__2Fi4-"};